/** Whether a stay got its survey: nothing yet, a link that is out, or at least one answer. */
export var SurveyDailySurveyState;
(function (SurveyDailySurveyState) {
    SurveyDailySurveyState["NOT_INVITED"] = "NOT_INVITED";
    SurveyDailySurveyState["INVITED"] = "INVITED";
    SurveyDailySurveyState["ANSWERED"] = "ANSWERED";
})(SurveyDailySurveyState || (SurveyDailySurveyState = {}));
/** A reservation group with two or more rooms on the day folds into one GROUP row, as on the CRM daily list. */
export var SurveyDailyRowKind;
(function (SurveyDailyRowKind) {
    SurveyDailyRowKind["GROUP"] = "GROUP";
    SurveyDailyRowKind["RESERVATION"] = "RESERVATION";
})(SurveyDailyRowKind || (SurveyDailyRowKind = {}));
